module.exports = __webpack_public_path__ + "img/mod_7.ec5a04b4.png";